import type { CSSProperties } from 'react';

interface PasswordRequirementsProps {
  readonly password: string;
  readonly className?: string;
  readonly containerStyle?: CSSProperties;
  readonly labelColor?: string;
  readonly successColor?: string;
}

const REQUIREMENTS: { label: string; test: (password: string) => boolean }[] = [
  { label: 'At least 10 characters', test: (password) => password.length >= 10 },
  { label: 'One lowercase letter', test: (password) => /[a-z]/.test(password) },
  { label: 'One uppercase letter', test: (password) => /[A-Z]/.test(password) },
  { label: 'One number', test: (password) => /\d/.test(password) },
  { label: 'One special character (#@$!%*?&-)', test: (password) => /[#@$!%*?&-]/.test(password) },
];

export default function PasswordRequirements({
  password,
  className = '',
  containerStyle,
  labelColor = '#757575',
  successColor = '#4CAF50',
}: PasswordRequirementsProps) {
  return (
    <div
      className={`rounded-lg border border-gray-200 bg-white p-4 ${className}`}
      style={containerStyle}
    >
      <p className="mb-2 text-xs" style={{ color: labelColor }}>Password must contain:</p>
      <ul className="grid grid-cols-1 gap-x-4 gap-y-1 text-xs sm:grid-cols-2">
        {REQUIREMENTS.map(({ label, test }) => (
          <li key={label} style={{ color: test(password) ? successColor : labelColor }}>
            • {label}
          </li>
        ))}
      </ul>
    </div>
  );
}
